import { render, staticRenderFns } from "./polygon6.vue?vue&type=template&id=37521f66&"
import script from "./polygon6.vue?vue&type=script&lang=ts&"
export * from "./polygon6.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports